export default __webpack_public_path__ + "static/media/8.48c4c2ca.jpg";